import type { NotificationRead } from '@/types/notification'

interface NotificationAction {
  label: string
  url: string
  state?: Record<string, unknown>
}

export function getNotificationAction(
  notification: NotificationRead
): NotificationAction | null {
  const planId = (notification.data?.plan_id as string) ?? null

  switch (notification.type) {
    case 'PLAN_SHARED':
    case 'OWNERSHIP_TRANSFERRED':
    case 'APPROVAL_DECISION':
    case 'PLAN_UNSUBMITTED':
    case 'PLAN_UNAPPROVED':
      return planId ? { label: 'Go to plan', url: `/plans/${planId}` } : null

    case 'APPROVAL_REQUIRED': {
      const data = notification.data as Record<string, unknown> | undefined
      const submissionId = data?.submission_id as string | undefined
      if (submissionId) {
        return {
          label: 'Go to approval',
          url: `/approvals/${submissionId}`,
          state: {
            submission: {
              submission_id: submissionId,
              plan_id: data?.plan_id ?? '',
              version_id: data?.version_id ?? '',
              plan_name: '',
              submitted_by: null,
              submitted_at: '',
              plan_status: '',
              submission_status: 'PENDING',
              seen_by_approver: false,
            },
          },
        }
      }
      return {
        label: 'Go to approval',
        url: notification.action_url ?? '/approvals',
      }
    }

    case 'COMMENT_ADDED': {
      if (!planId) return null
      const data = notification.data as Record<string, unknown> | undefined
      const nested = data?.data as Record<string, unknown> | undefined
      const isLineItem =
        notification.entity_type === 'line_item' ||
        data?.entity_type === 'line_item'
      const lineRefId =
        (data?.line_ref_id as string | undefined) ??
        (nested?.line_ref_id as string | undefined) ??
        (isLineItem
          ? ((notification.entity_id as string | undefined) ??
            (data?.entity_id as string | undefined))
          : undefined)

      if (lineRefId) {
        return {
          label: 'Go to comment',
          url: `/plans/${planId}?openComments=${lineRefId}`,
        }
      }
      return { label: 'Go to comments', url: `/plans/${planId}?tab=comments` }
    }

    default:
      return null
  }
}
